import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-modal-search-pacientes',
    templateUrl: './modal-search-pacientes.component.html',
    styleUrls: ['./modal-search-pacientes.component.scss']
})
export class ModalSearchPacientesComponent implements OnInit {

    form: FormGroup = new FormGroup({
        name: new FormControl(''),
        status: new FormControl(''),
        telefone: new FormControl(''),
        email: new FormControl(''),
        cns: new FormControl(''),
        cpf: new FormControl(''),
        dumLte: new FormControl(''),
        dumGte: new FormControl(''),
        usLte: new FormControl(''),
        usGte: new FormControl(''),
        usPartoLte: new FormControl(''),
        usPartoGte: new FormControl(''),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { stateForm: any },
        public dialogRef: MatDialogRef<ModalSearchPacientesComponent>
    ) { }

    ngOnInit() {
        if (this.data && this.data.stateForm) {
            if (this.data.stateForm.name) this.form.controls.name.setValue(this.data.stateForm.name);
            if (this.data.stateForm.status) this.form.controls.status.setValue(this.data.stateForm.status);
            if (this.data.stateForm.telefone) this.form.controls.telefone.setValue(this.data.stateForm.telefone);
            if (this.data.stateForm.email) this.form.controls.email.setValue(this.data.stateForm.email);
            if (this.data.stateForm.cns) this.form.controls.cns.setValue(this.data.stateForm.cns);
            if (this.data.stateForm.cpf) this.form.controls.cpf.setValue(this.data.stateForm.cpf);
            if (this.data.stateForm.dumLte) this.form.controls.dumLte.setValue(this.data.stateForm.dumLte);
            if (this.data.stateForm.dumGte) this.form.controls.dumGte.setValue(this.data.stateForm.dumGte);
            if (this.data.stateForm.usLte) this.form.controls.usLte.setValue(this.data.stateForm.usLte);
            if (this.data.stateForm.usGte) this.form.controls.usGte.setValue(this.data.stateForm.usGte);
            if (this.data.stateForm.usPartoLte) this.form.controls.usPartoLte.setValue(this.data.stateForm.usPartoLte);
            if (this.data.stateForm.usPartoGte) this.form.controls.usPartoGte.setValue(this.data.stateForm.usPartoGte);
        }
    }

    Salvar() {
        const dataForm: FormSearchPacientes = {
            name: this.form.controls.name.value,
            status: this.form.controls.status.value,
            telefone: this.form.controls.telefone.value,
            email: this.form.controls.email.value,
            cns: this.form.controls.cns.value,
            cpf: this.form.controls.cpf.value,
            dumLte: this.form.controls.dumLte.value,
            dumGte: this.form.controls.dumGte.value,
            usLte: this.form.controls.usLte.value,
            usGte: this.form.controls.usGte.value,
            usPartoLte: this.filterData(this.form.controls.usPartoLte.value),
            usPartoGte: this.filterData(this.form.controls.usPartoGte.value),
        }

        this.dialogRef.close(dataForm);
    }

    filterData(dataInput: any) {
        if (typeof dataInput === 'string') return dataInput.trim().toLowerCase();

        if (dataInput instanceof Date) return dataInput.toISOString();
        
        if (dataInput === null || dataInput === undefined) return null;
        
        return dataInput;
    }

    ResultadoRapido(dataInput) {
        this.dialogRef.close(dataInput);
    }

}
